import React from 'react';
import Box from '@mui/material/Box';
export var Spacer = function (_a) {
    var size = _a.size;
    var sizeToPass = size;
    if (size === 4) {
        sizeToPass = 5;
    }
    if (size === 5) {
        sizeToPass = 7;
    }
    if (size === 6) {
        sizeToPass = 9;
    }
    return React.createElement(Box, { pb: sizeToPass });
};
